<template>
  <div
    class="send_select_main"
    @click="openSelect"
  >
    <h3 class="form_props">
      {{ $t('message["275"]') }}
    </h3>
    <div class="form_content">
      <span v-if="members.length === 0">{{ $t('message["859"]') }}</span>
      <template
        v-for="item in members"
        v-else
      >
        <a-tag
          :key="item"
          class="tag"
          color="#5077AA"
          v-text="item"
        />
      </template>
      <i class="cubeic-arrow" />
    </div>
    <tree-list
      :visible.sync="selectVisible"
      :data="treeData"
      @close="closeSelect"
      @check="getCheckKeys"
    />
  </div>
</template>

<script type="text/ecmascript-6">
import treeList from './components/SelectCheckTree'
import { mapState, mapActions, mapMutations } from 'vuex'
export default {
  components: {
    treeList
  },
  data () {
    return {
      selectVisible: false
    }
  },
  computed: {
    ...mapState('costMaintain/costDetail', ['sendSelectTree', 'costContentData']),
    members () {
      return this.sendSelectTree.members
    },
    period () {
      const { period } = this.$route.query
      return period
    },
    key () {
      const { key } = this.$route.query
      return key
    },
    costId () {
      const { id } = this.$route.query
      return id
    },
    treeData () {
      return this.sendSelectLists(this.costContentData)
    }
  },
  created () {
    this.fetchMaintainTeam()
  },
  destroyed () {
    this.clearSendSelectTree()
  },
  methods: {
    ...mapActions('costMaintain/costDetail', ['fetchMaintainTeam']),
    ...mapMutations('costMaintain/costDetail', ['setSendSelectTree', 'clearSendSelectTree']),
    sendSelectLists (val) {
      if (!val) {
        return
      }
      let tempv = []
      if (Array.isArray(val)) {
        val.map(value => {
          let json = {
            title: value.name,
            value: value.keyname + '-' + value.id,
            key: value.keyname + '-' + value.id,
            children: []
          }
          if (value.children) {
            value.children.map(values => {
              let json2 = {
                title: values.name,
                value: value.keyname + '-' + value.id + '|' + values.keyname + '-' + values.id,
                key: value.keyname + '-' + value.id + '|' + values.keyname + '-' + values.id,
                children: []
              }
              if (values.children) {
                values.children.map(item => {
                  json2.children.push({
                    title: item.name,
                    value: value.keyname + '-' + value.id + '|' + values.keyname + '-' + values.id + '|' + item.keyname + '-' + item.id,
                    key: value.keyname + '-' + value.id + '|' + values.keyname + '-' + values.id + '|' + item.keyname + '-' + item.id
                  })
                })
              }
              json.children.push(json2)
            })
          }
          tempv.push(json)
        })
      }
      return tempv
    },
    getCheckKeys (result) {
      const { value, members } = result
      let sendJson = []
      if (Array.isArray(value)) {
        value.map(vvs => {
          const tempv = vvs.split('|')
          if (tempv.length === 1) {
            const vs = tempv[0].split('-')
            const json = {}
            json[vs[0]] = vs[1]
            sendJson.push(json)
          } else if (tempv.length === 2) {
            const roleidArr = tempv[0].split('-')
            const groupidArr = tempv[1].split('-')
            const json = {}
            json[roleidArr[0]] = roleidArr[1]
            json[groupidArr[0]] = groupidArr[1]
            if (sendJson.length === 0) {
              sendJson.push(json)
            } else {
              let isTrue = false
              sendJson.some(item => {
                if (item[roleidArr[0]] === roleidArr[1] && item[groupidArr[0]] === groupidArr[1]) {
                  item = json
                  isTrue = true
                }
              })
              if (isTrue) {
                return
              }
              sendJson.push(json)
            }
          } else if (tempv.length === 3) {
            const roleidArr = tempv[0].split('-')
            const groupidArr = tempv[1].split('-')
            const useridArr = tempv[2].split('-')
            const json = {}
            json[roleidArr[0]] = roleidArr[1]
            json[groupidArr[0]] = groupidArr[1]
            json[useridArr[0]] = [useridArr[1]]
            if (sendJson.length === 0) {
              sendJson.push(json)
            } else {
              let isTrue = false
              sendJson.some(item => {
                if (item[roleidArr[0]] === roleidArr[1] && item[groupidArr[0]] === groupidArr[1]) {
                  item[useridArr[0]].push(useridArr[1])
                  isTrue = true
                  return true
                }
              })
              if (isTrue) {
                return
              }
              sendJson.push(json)
            }
          }
        })
      }
      this.setSendSelectTree(Object.assign({}, { value: sendJson }, { members }))
    },
    openSelect () {
      this.selectVisible = true
    },
    closeSelect (res) {
      this.selectVisible = res
    }
  }
}
</script>

<style scoped lang="scss">
.send_select_main {
  position: relative;
  min-height: 48px;
  border-bottom: 1px solid #dbdbdb;
  background: #fff;
  margin: 12px 0;
  overflow: hidden;
  .form_props {
    display: inline;
    color: #333;
    line-height: 48px;
    text-align: left;
    margin: 12px;
    vertical-align: middle;
  }
  .form_content {
    display: inline-block;
    width: 250px;
    color: #999;
    vertical-align: middle;
    .tag {
      margin: 5px
    }
    .cubeic-arrow {
      position: absolute;
      right: 22px;
      top: 50%;
      transform: translateY(-50%);
      color: #ccc;
    }
  }
}
</style>
